var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "onboarding-block" }, [
    _c(
      "div",
      { staticClass: "onboarding-block-wrap" },
      [
        _c("h3", { staticClass: "onboarding-heading" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.steps === 0 ? "Personal Information" : "Review and Submit"
              ) +
              " "
          ),
        ]),
        _c("StepProgress", {
          attrs: { steps: _vm.steps, activeStep: _vm.activeStep },
        }),
        _vm.activeStep === 0
          ? _c("Step1", {
              attrs: { record: _vm.record, currentUser: _vm.currentUser },
              on: { onContinue: _vm.onContinue },
            })
          : _c("Step2", {
              attrs: {
                currentUser: _vm.currentUser,
                form: _vm.record,
                goToPreviousStep: _vm.goToPreviousStep,
              },
              on: {
                goToPreviousStep: _vm.goToPreviousStep,
                refetch: function ($event) {
                  return _vm.$emit("refetch")
                },
              },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }